import { MemberStatusType, SubscriptionStatus } from '../enums';
import { SUBSCRIPTION_STATUS_CONFIG } from '../constants';

/**
 * Builds the tooltip of a member's status. Both coverages feed the same status,
 * so the tooltip names the one it comes from.
 */
export function buildMemberStatusTooltip(statusType: MemberStatusType | undefined, status: SubscriptionStatus): string {
  const statusLabel = SUBSCRIPTION_STATUS_CONFIG[status].tooltip;

  switch (statusType) {
    case MemberStatusType.COURTESY:
      return `Cortesía · ${statusLabel}`;
    case MemberStatusType.SUBSCRIPTION:
      return `Suscripción · ${statusLabel}`;
    default:
      return statusLabel;
  }
}
